import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../api/client";

// POST /api/v1/payments/
// Body: { student, amount, method, period_start, period_end, receipt_number, date }
// Contract: TASK-13 §8 (vertiente owner — owner registra el pago del estudiante)
function useRegisterPayment() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data) =>
      apiClient.post("/api/v1/payments/", data).then((r) => r.data),
    onSuccess: () => {
      // The owner's payment list (useOwnerPayments) is keyed ["owner-payments"];
      // invalidate it so the new payment appears immediately. Also refresh the
      // student-facing list and the portfolio (cartera) which depend on payments.
      qc.invalidateQueries({ queryKey: ["owner-payments"] });
      qc.invalidateQueries({ queryKey: ["student-payments"] });
      qc.invalidateQueries({ queryKey: ["portfolio"] });
    },
  });
}

export { useRegisterPayment };
